import client from "../libs/HttpClient";

class QuoteService {
  static addQuote(request) {
    console.log("request",request)
    return client.post("/quoteDetails", request);
  }
}
export { QuoteService };
